import useUser from '../../core/hooks/useUser';
import { LANGUAGE_METADATA, BUSINESS_TYPE_METADATA, PARTNER_METADATA } from '../../social/constants';
const useUserFilters = (userId) => {
    var _a, _b, _c;
    const { user } = useUser(userId);
    const metadata = (_a = user === null || user === void 0 ? void 0 : user.metadata) !== null && _a !== void 0 ? _a : {};
    return {
        localeLanguage: (_b = metadata[LANGUAGE_METADATA]) !== null && _b !== void 0 ? _b : ['en'],
        businessType: (_c = metadata[BUSINESS_TYPE_METADATA]) !== null && _c !== void 0 ? _c : 'B2C',
        partnerId: metadata[PARTNER_METADATA],
    };
};
export default useUserFilters;
//# sourceMappingURL=useUserFilters.js.map